export const baseUrl = "https://webay-backend.herokuapp.com";

// export const baseUrl = "http://localhost:4000";

export const localStorageJwtKey = "currentUserJwt";
